import React from 'react'
import { trans } from '@/_providers/Translation'
import brandImage from '@/assets/img/login/brand.svg'
import '@/assets/scss/app/error-fallback.scss'

const ErrorFallback = ({ eventId }) => {
    const handleReload = () => {
        window.location.reload()
    }

    const handleHome = () => {
        window.location.href = '/'
    }

    return (
        <div className="error-fallback">
            <div className="error-fallback__card">
                <img src={brandImage} alt="" className="error-fallback__brand" />

                <div className="error-fallback__icon">
                    <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                        <line x1="12" y1="9" x2="12" y2="13" />
                        <line x1="12" y1="17" x2="12.01" y2="17" />
                    </svg>
                </div>

                <h1 className="error-fallback__heading">{trans('errorBoundary.heading')}</h1>
                <p className="error-fallback__message">{trans('errorBoundary.message')}</p>

                <div className="error-fallback__actions">
                    <button className="button-primary" onClick={handleReload}>
                        {trans('errorBoundary.reload')}
                    </button>
                    <button className="button-secondary" onClick={handleHome}>
                        {trans('errorBoundary.home')}
                    </button>
                </div>

                {eventId && (
                    <p className="error-fallback__code">
                        {trans('errorBoundary.code')}: <span>{eventId}</span>
                    </p>
                )}
            </div>
        </div>
    )
}

export default ErrorFallback
